import * as EventService from 'modules/event-manager/event-manager.actions';
import { State } from 'widgets/free-content/root/root.reducers';
import { IOwnershipRequest } from 'modules/event-manager/event-manager.service';
import { Dispatch } from 'types/dispatch';

export const eventApplyOwnership = () => (dispatch: Dispatch, getState: () => State) => {
    const state: State = getState();

    const {
        login,
        config,
        event,
        platform: platformId
    } = state;

    if (!(login.loginSession && config && event && platformId)) {
        throw 'Could not perform ownership request due to lack of input data';
    }

    const { UbisoftConnectTicket, UbisoftConnectProfiles } = login.loginSession!;
    const profilePlatform = UbisoftConnectProfiles.find(
        (profile: { id: string }) => profile.id === platformId
    );

    if (!profilePlatform || !profilePlatform.userId) {
        throw 'No available platform user was found';
    }

    const ownershipRequest: IOwnershipRequest = {
        eventCode: event.data!.code,
        userId: profilePlatform.userId,
        UbisoftConnectTicket,
        applicationId: config.applicationId
    };

    dispatch(EventService.eventApplyOwnership(ownershipRequest));
};
